export default "__VITE_ASSET__f3b18b42__"